<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">{{operationType}} Hierarchy
  <div class="pull-right">
    <a class="boxclose" (click)="closeDialog()"></a>
  </div>
</h2>
<mat-dialog-content class="">
  <nb-card>
    <form class="form-horizontal p-2" [formGroup]="formUserHierarchy">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <mat-form-field>
            <mat-select (selectionChange)="showForm();" placeholder="Select hierarchy level you want to add"
              formControlName="UserHierarchyLevel">
              <mat-option value="Region">Region</mat-option>
              <mat-option value="Division">Division</mat-option>
              <mat-option value="Location">Location</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="showAddForm">
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyName" placeholder="Name" matInput required>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyName.touched && formUserHierarchy.controls.UserHierarchyName.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyName.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Name is required
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3" *ngIf="hierarchy === 'Location' || hierarchy === 'Division'">
          <mat-form-field>
            <mat-select placeholder="Select Region" formControlName="UserHierarchyRegion" required
              (selectionChange)="showDivision();">
              <mat-option *ngFor="let region of regionData" [value]="region">{{region.customerName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyRegion.touched && formUserHierarchy.controls.UserHierarchyRegion.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyRegion.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Region is required
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3" *ngIf="hierarchy === 'Location'">
          <mat-form-field>
            <mat-select placeholder="Select Division" formControlName="UserHierarchyDivision" required
              (selectionChange)="showRegion();">
              <ng-container *ngFor="let division of divisionData">
                <mat-option *ngIf="division.subCustomerKey == regionId || regionId == null" [value]="division">
                  {{division.customerName}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyDivision.touched && formUserHierarchy.controls.UserHierarchyDivision.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyDivision.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Division is required
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyId" placeholder="{{hierarchyLevel}}" matInput
              required>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyId.touched && formUserHierarchy.controls.UserHierarchyId.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyId.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                {{hierarchyLevel}} is required
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyAddress" placeholder="Address" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyCity" placeholder="City" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <mat-select placeholder="State" formControlName="UserHierarchyState">
              <mat-option *ngFor="let st of preSignUpSTDetails" [value]="st.StateTypeCode">{{st.StateTypeName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyZip" placeholder="Zip code" matInput>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyZip.touched && formUserHierarchy.controls.UserHierarchyZip.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyZip.errors.pattern">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Zip code should contain digits only
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3" *ngIf="hierarchy != 'Division'">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyPhone" placeholder="Phone number" matInput>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyPhone.touched && formUserHierarchy.controls.UserHierarchyPhone.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyPhone.errors.pattern">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Phone number should contain digits only
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyDayPhone" placeholder="Day Phone" matInput>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyDayPhone.touched && formUserHierarchy.controls.UserHierarchyDayPhone.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyDayPhone.errors.pattern">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Day phone should contain digits only.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyNightPhone" placeholder="Night Phone"
              matInput>
          </mat-form-field>
          <div
            *ngIf="formUserHierarchy.controls.UserHierarchyNightPhone.touched && formUserHierarchy.controls.UserHierarchyNightPhone.errors"
            class="error">
            <div *ngIf="formUserHierarchy.controls.UserHierarchyNightPhone.errors.pattern">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Night phone should contain digits only
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3">
          <mat-form-field>
            <input type="text" class="w-100" formControlName="UserHierarchyResponsibleParty"
              placeholder="Responsible Party" matInput>
          </mat-form-field>
        </div>
      </div>
    </form>
  </nb-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-success btn-semi-round btn-demo bgBlue pull-right mr-2" (click)="addEditHierarchy()"
    [disabled]="formUserHierarchy.invalid">
    Save </button>
  <button (click)="closeDialog()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>